import _ from 'lodash';
import {
  OBITUARIES_ERROR,
  OBITUARIES_SUCCESS,
  OBITUARIES_REQUEST,
} from '../actions';
import {combineReducers} from 'redux';

const hasMoreItemsToShow = (requestItemCount, responseItemCount) =>
  requestItemCount <= responseItemCount;

export const loading = (state = false, action) => {
  switch (action.type) {
    case OBITUARIES_REQUEST:
      return true;
    case OBITUARIES_ERROR:
    case OBITUARIES_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const people = (state = [], action) => {
  const peopleWithObituaries =
    _.get(action, 'response.data.funeralHomeObituaries.people') || [];

  switch (action.type) {
    case OBITUARIES_SUCCESS:
      return [...state, ...peopleWithObituaries];
    default:
      return state;
  }
};

export const page = (state = 0, action) => {
  switch (action.type) {
    case OBITUARIES_SUCCESS:
      return state + 1;
    default:
      return state;
  }
};

export const showLoadMoreButton = (state = true, action) => {
  switch (action.type) {
    case OBITUARIES_SUCCESS:
      const peopleWithObituaries =
        _.get(action, 'response.data.funeralHomeObituaries.people') || [];

      return hasMoreItemsToShow(action.count, peopleWithObituaries.length);
    case OBITUARIES_ERROR:
      return false;
    default:
      return state;
  }
};

export const error = (state = {}, action) => {
  switch (action.type) {
    case OBITUARIES_REQUEST:
    case OBITUARIES_SUCCESS:
      return {};
    case OBITUARIES_ERROR:
      return action.error;
    default:
      return state;
  }
};

export default combineReducers({
  loading,
  people,
  page,
  showLoadMoreButton,
  error,
});



// WEBPACK FOOTER //
// ./src/reactModules/redux/reducers/obituaryStore.js